<script setup lang="ts">
import { Search } from '@element-plus/icons-vue'
import { computed } from 'vue'

interface Props {
  modelValue?: string
  placeholder?: string
  size?: 'large' | 'default' | 'small'
  disabled?: boolean
  clearable?: boolean
}

interface Emits {
  (e: 'update:modelValue', value: string): void
  (e: 'search', value: string): void
  (e: 'clear'): void
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: '',
  placeholder: 'search',
  size: 'default',
  disabled: false,
  clearable: true,
})

const emit = defineEmits<Emits>()

const inputValue = computed({
  get: () => props.modelValue,
  set: (value: string) => emit('update:modelValue', value),
})

function handleInput(value: string) {
  emit('update:modelValue', value)
}

function handleSearch() {
  emit('search', inputValue.value)
}

function handleClear() {
  emit('clear')
}
</script>

<template>
  <ElInput
    v-model="inputValue"
    :placeholder="$t(placeholder)"
    :size="size"
    :disabled="disabled"
    :clearable="clearable"
    class="search-input"
    @input="handleInput"
    @clear="handleClear"
    @keyup.enter="handleSearch"
  >
    <template #prefix>
      <ElIcon class="search-icon">
        <Search />
      </ElIcon>
    </template>
  </ElInput>
</template>

<style scoped>
.search-input {
  width: 100%;
}

.search-input :deep(.el-input__wrapper) {
  border-radius: 8px;
}

.search-input :deep(.el-input__prefix) {
  color: var(--el-text-color-placeholder);
}

.search-icon {
  font-size: 16px;
}
</style>
